export default function filterUniqueByImage(cards) {
  const sortedOptionsSet = {};
  return cards.filter(card => {
    const { image } = card;
    if (!sortedOptionsSet[image]) {
      sortedOptionsSet[image] = image;
      return true;
    }
    return false;
  });
}
